export default __webpack_public_path__ + "static/media/logo_footer.d0568357.svg";